import { render } from "./table-action.vue?vue&type=template&id=c80ccd76&ts=true"
import script from "./table-action.vue?vue&type=script&lang=ts"
export * from "./table-action.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__